import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Necesito conocimientos contables?',
    answer: 'No. Está escrito en español simple para gente real.'
  }, {
    question: '¿Cómo recibo el material?',
    answer: 'Por email inmediatamente. PDF. Acceso de por vida.'
  }, {
    question: '¿Qué pasa si cambian las escalas de Monotributo?',
    answer: 'El Kit enseña la lógica del sistema. Funciona con cualquier escala. Actualizaciones incluidas sin costo.'
  }, {
    question: '¿Sirve si soy empleado además de monotributista?',
    answer: 'Sí. El Tomo 3 y el Manual del Reintegro aplican directamente a tu situación mixta.'
  }];
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-[#FAF5EC]" data-id="element-51">
      <div className="max-w-3xl mx-auto" data-id="element-52">
        <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12 text-[#1A1A1A]" data-id="element-53">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-54">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-[#EAE5DC] shadow-sm rounded-lg overflow-hidden" data-id="element-55">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full p-6 text-left flex items-center justify-between hover:bg-[#FAF7F2] transition-colors" data-id="element-56">
                <span className="font-semibold text-[#1A1A1A] pr-4" data-id="element-57">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-[#5BB4A0] flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-58" />
              </button>
              <AnimatePresence data-id="element-59">
                {openIndex === index && <motion.div initial={{
              height: 0
            }} animate={{
              height: 'auto'
            }} exit={{
              height: 0
            }} transition={{
              duration: 0.2
            }} className="overflow-hidden" data-id="element-60">
                    <div className="px-6 pb-6 text-[#6B7280]" data-id="element-61">{faq.answer}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}